<template>
    <div class="note-form-basic">
        <div class="form-group">
            <label for="note">Minuta</label>
            <textarea name="note" id="note" cols="30" rows="4" v-model.trim="note.content" class="form-control" @input="updateContent"></textarea>
            <span class="field-error" v-if="$v.note.content.$error">Debe escribir la anotación</span>
        </div>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators';
    export default {
        props: {
            typeNote: {
                type: String,
                default: ''
            }

        },
        data(){
            return {
                note: {
                    content: ''
                }
            }
        },
        validations: {
            note: {
                content: { required }
            }
        },
        methods: {
            updateContent(){
                this.$v.note.content.$touch();
                this.$emit('input', this.content);
            },
            cleanFields(){
                  Object.keys(this.note).map(key => this.note[key] = '');
                  this.$v.$reset();
                },
            isValid(){
                this.$v.$touch();
                return !this.$v.$invalid;
            }
        },
        computed: {
            content(){
                return this.note.content;
            }
        },
        created() {
             this.$bus.$on('note-form-basic.clean', this.cleanFields);
        }
    }
</script>